// 同盾防刷
import events from '@js/base/events';
import Url from 'c-url';

const env = Url.query('env');
const isStage = env == 'stage';

let TD = Object.assign(
    {
        init() {
            (function () {
                let partner = isStage ? 'Uplivetest' : 'Uplive';
                let appName = isStage ? 'test_h5' : 'Uplive_h5';
                let token = `${isStage ? 'demo' : 'Uplive_h5'}-${new Date().getTime()}-${Math.random().toString(16).substr(2)}`;

                window._fmOpt = {
                    // 注意：partner、appName需要替换成同盾分配的值
                    partner,
                    appName,
                    token,
                    success: function (data) {
                        // 在成功完成采集后，success回调中可以获取到blackbox，在获取到blackbox后传输过程中请进行url编码
                        console.log('同盾初始化完成: ', data);
                        window.tdBlackBox = data;
                        $.channel.emit('tdsdkLoaded', data);
                    },
                    fpHost: 'https://sgfp.tongdun.net',
                };
                var fm = document.createElement('script');
                fm.type = 'text/javascript';
                fm.async = true;
                fm.src =
                    ('https:' == document.location.protocol
                        ? 'https://'
                        : 'http://') +
                    'static.tongdun.net/sg/fm.js?ver=0.1&t=' +
                    (new Date().getTime() / 3600000).toFixed(0);
                var s = document.getElementsByTagName('script')[0];
                s.parentNode.insertBefore(fm, s);
            })();
        },
    },
    events
);

TD.init();



// WEBPACK FOOTER //
// ./js/component/TD/index.js